<template>
  <transition name="fade" mode="out-in">

    <div class="animated fadeIn form-mimoto">

    <CRow class="mb-4">
      <CCol md="12">
        <!-- <h2> <strong> {{elemento}}</strong> </h2>
        <p class="mb-0">Plan XXX en el parking XXX</p> -->

        <h5 class="subtitle mb-1">{{ step }}. Finalizado</h5>
      </CCol>
    </CRow>


    <CCard>
      <CCardBody borderColor="primary text-center">
        <!-- <h5 class="subtitle mb-1">{{ step }}. Finalizado</h5> -->
        <!-- <p class="mb-3 text-primary">Pulsa siguiente para confirmar el pedido</p> -->

        <h3  class="mb-3 text-primary" style="font-weight: 600">
          <span v-if="product && product.id ">¡Enhorabuena!</span>  <span  v-else> Incompleto</span>
        </h3>

        <p v-if="product && product.id " class="mb-3 text-primary">Has contratado un nuevo plan prepago,
          disfruta de cualquier parking de la red mimoto. </p>
        <p v-else class="mb-3 text-primary">
          <span v-if="!product">Pedido sin definir. Vuelve al paso 1 para seleccionar las fechas de inicio y fin del plan</span>
          <span v-else>Pedido pendiente de pago, vuelve al paso anterior para abonar el servicio</span>
        </p>


         <div v-if="product && product.id" class="my-3">
           <img :src="require('@/assets/img/success-moto.png')"
           width="90px" alt="Icono de un trofeo" class="mb-2 mt-3">
            <!-- buentrabajo_720x1280.png -->
           <!-- success-moto -->

          <!-- <p class="mt-3 mb-0 text-primary">En breve comenzará su ruta. </p> -->

        </div>



        <p class="invalid-feedback d-block mt-4 mb-3">
          {{ message }}
        </p>

       <toast ref="toast"></toast>

      </CCardBody>
    </CCard>

    <div class="title-container mb-3 btn-new-delivery">
      <button @click.prevent="nextStep" class="btn-login-custom btn" >
        <!-- Siguiente -->
        ver mis planes
      </button>
    </div>

    <spinner-ttt :show="loading"></spinner-ttt>


    </div>
  </transition>
</template>

<script>
import validator from "@/validator";
// import apiTools from "@/app/shared/utils/apiTools"
import { CALENDAR_LANG } from "@/config";

import { removeProductStore, getProductStore } from "@/app/shared/global/services/product-service";


export default {
  name: "DetallePlanSuccess",
  components: {

  },
  props: {
    plan: { type: Object, default() {return {}}, required: true },
    parkingPlan: { type: Object, default() {return {}},required: true },
    // client: { type: Object, default() {return {}},required: true },
  },
  data() {
    return {
      step: 3,
      elemento: "Pedido finalizado",
      loading: true,
      message: null,

      product: {
        clients_id: localStorage.getItem('user_id'),
        towns_id: null, // solo para ir hacia a trás
        parkings_id: null,
        plans_id: null, // plans
        start_datetime: null,
        end_datetime: null,
        dates: [],
        hours:[],
      },

      errorDates: false,
      lang: CALENDAR_LANG,

      contractPlanApi: null,

      parking: null,

    };
  },

  destroyed() {
    removeProductStore();
  },

  created() {

  },
  mounted(){

    this.$emit("updateStep", this);
    this.$emit("showButtons", false);

    if (getProductStore()){
      this.setDataLocalStorage();
    }

    this.loading = false;

  },

  methods: {
    setDataLocalStorage() {

      const errorMessage = `Se ha producido un error al obtener los datos en curso`;
      this.loading = true;

      try {

        let storedData = getProductStore();

        if (storedData) {

          this.product = {
            ...storedData,
            // id: 15  // TODO: eliminar cuando se habilite el pago
          };
        }

      } catch (e) {
        console.log(e);
        // this.$refs.toast.showToast(`${errorMessage}`,null,"warn","5000");
      } finally {
        this.loading = false;
      }

    },

    nextStep() {

      this.loading = true;

      this.deleteDataLocalStorage();
      this.$router.push(`/gestion/contrataciones`);

      this.loading = false;

    },
    deleteDataLocalStorage() {
      removeProductStore()
    }



  }
};
</script>

<style lang="scss" scoped>


.input-group-append {
  .input-group-text {
    color: #1c1f22; //#5c6873;
    background-color: var(--theme-color-primary)!important;// #f0f3f5; //
    border-color: var(--theme-color-primary); //#e4e7ea;
  }
}


</style>
